/**
 * @module free-shipping-bar/format
 *
 * Currency formatting helpers for the Shipping Progress Bar message.
 */

import { CURRENCY_SYMBOLS, ZERO_DECIMAL_CURRENCIES } from './config.js';

export function isZeroDecimalCurrency(currency: string): boolean {
  return ZERO_DECIMAL_CURRENCIES.includes(currency);
}

/**
 * Format a major-unit amount for display, preferring Intl and falling back to
 * a manual symbol + number when Intl rejects the currency code.
 * @param {number} amount - amount in major units (e.g. 12.50)
 * @param {string} currency - ISO currency code
 * @returns {string}
 */
export function formatCurrency(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: isZeroDecimalCurrency(currency) ? 0 : 2,
      maximumFractionDigits: isZeroDecimalCurrency(currency) ? 0 : 2,
    }).format(amount);
  } catch {
    // Fallback to manual formatting
    const symbol = CURRENCY_SYMBOLS[currency] || currency + ' ';
    const formatted = isZeroDecimalCurrency(currency)
      ? Math.round(amount).toLocaleString()
      : amount.toFixed(2);
    return `${symbol}${formatted}`;
  }
}
